import { useState } from 'react';

import { Link } from '@tanstack/react-router';
import { Popover, PopoverContent, PopoverTrigger } from 'cpool-components/general/Popover';
import { useTranslation } from 'react-i18next';
import { LuEllipsisVertical } from 'react-icons/lu';

import { ArchiveChatMenuItem } from '~/features/whatsapp/components/ChatPanel/ArchiveChatMenuItem';
import { useChatContextLoanRequestId } from '~/features/whatsapp/hooks/useChatContextLoanRequestId';
import { CHAT_PANEL_VIEWS, pushChatPanelView, useChatPanelStore } from '~/features/whatsapp/stores/chatPanelStore';

type Props = {
    canLink: boolean;
    chatId: string;
    resolved: boolean;
    loanRequestIds: Array<string>;
};

export const OverflowMenu = ({ canLink, chatId, loanRequestIds, resolved }: Props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    // Opened chat (not the pane's KN1/KN2 chat) so lead context matches ChatView.
    const activeChatId = useChatPanelStore.use.activeChatId();
    const primaryLoanRequestId = useChatContextLoanRequestId(activeChatId);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    className="flex items-center text-midnight"
                    aria-label={t('WHATSAPP_CHAT.MENU.LABEL')}
                >
                    <LuEllipsisVertical size={18} />
                </button>
            </PopoverTrigger>
            <PopoverContent side="bottom" align="end" sideOffset={4} className="w-56 p-1">
                <button
                    type="button"
                    className="w-full rounded px-3 py-2 text-left text-sm hover:bg-surface-light"
                    onClick={() => {
                        setOpen(false);
                        pushChatPanelView(CHAT_PANEL_VIEWS.USER_INFO);
                    }}
                >
                    {t('WHATSAPP_CHAT.MENU.OPEN_CONTACT_PROFILE')}
                </button>
                {loanRequestIds.length === 0 && canLink && (
                    <button
                        type="button"
                        className="w-full rounded px-3 py-2 text-left text-sm hover:bg-surface-light"
                        onClick={() => {
                            setOpen(false);
                            pushChatPanelView(CHAT_PANEL_VIEWS.USER_INFO);
                        }}
                    >
                        {t('WHATSAPP_CHAT.MENU.LINK_CASE')}
                    </button>
                )}
                {primaryLoanRequestId && loanRequestIds.length > 0 && (
                    <Link
                        to="/leads/details/$leadId"
                        params={{ leadId: primaryLoanRequestId }}
                        onClick={() => setOpen(false)}
                        className="block w-full rounded px-3 py-2 text-left text-sm hover:bg-surface-light"
                    >
                        {t('WHATSAPP_CHAT.MENU.JUMP_TO_CASE')}
                    </Link>
                )}
                <ArchiveChatMenuItem chatId={chatId} resolved={resolved} onSelect={() => setOpen(false)} />
            </PopoverContent>
        </Popover>
    );
};
